import { Page } from "modules/Page";
import { debounce } from "modules/debounce";
import { NewsListingApi, newsListingsApi, NewsListingsQueryParams } from "api/NewsListingApi";
import newsListingTemplate from "./NewsListingPage.hbs";
import { Select } from "components/Select/Select";

export class NewsListingPage extends Page<typeof NewsListingPage> {
    static readonly className = "js-news-listing-page";

    private api: NewsListingApi = newsListingsApi;
    private newsListElement!: HTMLElement;
    private newsListLoader!: HTMLElement;
    private loadMoreButton!: HTMLButtonElement;
    private yearSelect: Select | null = null;

    private pageID!: string;
    private page = 1;
    private totalPages = 0;

    constructor(rootElement: HTMLElement, index: number) {
        super(rootElement, index);

        this.pageID = rootElement.dataset.pageid || "0";
        this.newsListElement = rootElement.querySelector<HTMLElement>(".news__list")!;
        this.newsListLoader = rootElement.querySelector<HTMLElement>(".list__loader")!;
        this.loadMoreButton = rootElement.querySelector<HTMLButtonElement>("#load-more-button")!;
        // initialize Select component for year filter
        this.yearSelect = this.getComponent<Select>("[name='year']");
        this.yearSelect?.on("change", this.onYearChange);

        this.loadMoreButton.addEventListener("click", this.loadNextPage);
        

        this.refreshNewsListings();
    }

    private getRequestParams(): NewsListingsQueryParams {
        const params: NewsListingsQueryParams = {
            pageID: this.pageID,
            page: this.page,
            lang: document.documentElement.lang
        };
        if (this.yearSelect) {
            const selectedYears = this.yearSelect.getSelectedValues(); // Select component API 
            if (selectedYears.length > 0) { params.year = selectedYears.join(","); }
        }
        return params;
    }
    private onYearChange = (selectedValues: string[]) => { const params = new URLSearchParams(window.location.search); if (selectedValues.length > 0) { params.set("year", selectedValues.join(",")); } else { params.delete("year"); } history.replaceState({}, "", `${location.pathname}?${params}`); this.page = 1; this.refreshNewsListings(); };
    
    private refreshNewsListings = debounce(async () => {
        this.page = 1;
        this.newsListLoader.style.display = "block";
        this.newsListElement.style.display = "none";
        this.loadMoreButton.disabled = true;

        const params = this.getRequestParams();
        const pageData = await this.api.getNewsListings(params);

        this.totalPages = pageData.totalPages;
        this.newsListElement.innerHTML = newsListingTemplate({ newsListings: pageData.newsListings });
        console.log("newsListings data:", pageData.newsListings);

        this.newsListLoader.style.display = "none";
        this.newsListElement.style.display = "grid";
        this.loadMoreButton.disabled = this.page >= this.totalPages;
    }, 300);

    private loadNextPage = debounce(async () => {
        if (this.page >= this.totalPages) return;

        this.page++;
        this.loadMoreButton.disabled = true;

        const params = this.getRequestParams();
        const pageData = await this.api.getNewsListings(params);

        this.newsListElement.insertAdjacentHTML(
            "beforeend",
            newsListingTemplate({ newsListings: pageData.newsListings })
        );

        this.loadMoreButton.disabled = this.page >= this.totalPages;
    }, 300);
}
